module.exports = __webpack_public_path__ + "img/logo_old.f50945f0.png";